
import { useTranslation } from "react-i18next";
import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";
import { CreateExternalLinkTo } from "shared/constants/linkTo";

export const usePortfolio365Tabs = () => {
  const { t } = useTranslation()  

  return {
    [NAVBAR_TAB_NAMES.portfolio_catalog]: {
      active: false,
      content: t("nav.portfolio_365.catalog"),
      level: 2,
      linkTo: CreateExternalLinkTo.portfolio365('/catalog/creative_art?card=02247e78f4a043afb2db513b9043397b'),
      target: '_blank',
    },
    [NAVBAR_TAB_NAMES.portfolio_portfolio]: {
      active: false,
      content: t("nav.portfolio_365.portfolio"),
      level: 2,
      linkTo: CreateExternalLinkTo.portfolio365('/catalog/creative_art?card=02247e78f4a043afb2db513b9043397b'),
      target: '_blank',
    },
    [NAVBAR_TAB_NAMES.portfolio_tags]: {
      active: false,
      content: t("nav.portfolio_365.tags"),
      level: 2,
      linkTo: CreateExternalLinkTo.portfolio365('/tags'),
      target: '_blank',
    },
    [NAVBAR_TAB_NAMES.portfolio_competitions]: {
      content: t("nav.competitions"),
      level: 2,
      linkTo: '/',
    },
    [NAVBAR_TAB_NAMES.portfolio_about]: {
      active: false,
      content: t("nav.portfolio_365.about"),
      level: 2,
      linkTo: CreateExternalLinkTo.portfolio365('/about'),
      target: '_blank',
    },
  }
}
import { useTranslation } from "react-i18next";
import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";
import { CreateExternalLinkTo } from "shared/constants/linkTo";

export const usePortfolio365Tabs = () => {
  const { t } = useTranslation()  

  return {
    [NAVBAR_TAB_NAMES.portfolio_catalog]: {
      active: false,
      content: t("nav.portfolio_365.catalog"),
      level: 2,
      linkTo: CreateExternalLinkTo.portfolio365('/catalog/creative_art?card=02247e78f4a043afb2db513b9043397b'),
      target: '_blank',
    },
    [NAVBAR_TAB_NAMES.portfolio_portfolio]: {
      active: false,
      content: t("nav.portfolio_365.portfolio"),
      level: 2,
      linkTo: CreateExternalLinkTo.portfolio365('/catalog/creative_art?card=02247e78f4a043afb2db513b9043397b'),
      target: '_blank',
    },
    [NAVBAR_TAB_NAMES.portfolio_tags]: {
      active: false,
      content: t("nav.portfolio_365.tags"),
      level: 2,
      linkTo: CreateExternalLinkTo.portfolio365('/tags'),
      target: '_blank',
    },
    [NAVBAR_TAB_NAMES.portfolio_competitions]: {
      content: t("nav.competitions"),
      level: 2,
      linkTo: '/',
    },
    [NAVBAR_TAB_NAMES.portfolio_about]: {
      active: false,
      content: t("nav.portfolio_365.about"),
      level: 2,
      linkTo: CreateExternalLinkTo.portfolio365('/about'),
      target: '_blank',
    },
  }
}